<template>
  <tr>
    <td v-if="! accumulated">{{ stockRotation.created_at | datetime }}</td>
    <td>
      <strong v-if="! accumulated && stockRotation.box">Box: </strong>
      <router-link :to="`/products/${stockRotation.product.id}`">
        {{ stockRotation.product.is_box ? stockRotation.product.box_name : stockRotation.product.name }}
      </router-link>
    </td>
    <td :class="getDirectionClass()" class="text-right">
      {{ formattedQuantity() }}
    </td>
    <td class="text-right" v-if="! accumulated">
      <span v-if="showPrice">
        {{ stockRotation.price | priceFromCentEuro }}
      </span>
    </td>
    <td v-if="accumulated" :class="stockRotation.quantity_in > 0 ? 'rotation-in' : ''"
        class="text-right"
    >
      {{ stockRotation.quantity_in }}
    </td>
    <td v-if="accumulated" :class="stockRotation.quantity_out < 0 ? 'rotation-out' : ''"
      class="text-right"
    >
      {{ stockRotation.quantity_out * -1 }}
    </td>
    <td v-if="accumulated"
      class="text-right"
    >
      {{ stockRotation.einkaufspreis | priceFromCentEuro }}
    </td>
    <td v-if="accumulated"
      class="text-right"
    >
      {{ (stockRotation.einkaufspreis  * stockRotation.quantity )| priceFromCentEuro  }}
    </td>
    <td v-text="stockRotation.warehouse.short_name" v-if="showWarehouse"></td>
    <td v-if="! accumulated">
      <a target="_blank" :href="`${$store.state.mobimedUrl}/invoices?invoiceNumber=${stockRotation.invoice_number}`"
        v-if="stockRotation.invoice_id"
        v-tooltip.top-center="stockRotation.invoice_number"
      >
        {{ stockRotation.cause ? stockRotation.cause.name : '' }}
      </a>
      <span v-text="stockRotation.cause ? stockRotation.cause.name : ''" v-else></span>
      <span v-if="stockRotation.comment">
        <el-tooltip placement="top">
          <div slot="content" v-html="stockRotation.comment" style="white-space: pre-wrap;"></div>
          <i class="fas fa-info-circle" style="margin-left: 5px;"></i>
        </el-tooltip>
      </span>
      <span v-if="getStockrotationInfo(stockRotation)">
        <el-tooltip placement="top">
          <div slot="content" v-html="getStockrotationInfo(stockRotation)" style="white-space: pre-wrap;"></div>
          <i class="fas fa-info-circle" style="margin-left: 5px;"></i>
        </el-tooltip>
      </span>
    </td>
    <td v-if="! accumulated" v-text="stockRotation.user.name"></td>
    <td v-if="! accumulated" v-text="stockRotation.cost_center ? stockRotation.cost_center.name : ''"></td>

    <td class="text-right" v-if="! accumulated">
      <div class="td-actions-custom" v-if="isAllowedToDelete">
        <a v-tooltip.top-center="'Löschen'" class="btn btn-danger btn-link btn-xs"
           @click="$emit('deleteStockRotation', stockRotation)">
          <i class="fa fa-close"></i>
        </a>
      </div>
    </td>
  </tr>
</template>

<script>
export default {
  props: ['stockRotation', 'accumulated', 'showWarehouse'],
  computed: {
    showPrice () {
      // frontdesk must not see einkaufspreis
      if (this.$store.getters.isFrontdesk) {
        return +this.stockRotation.cause.direction === -1
      }
      return true
    },
    isAllowedToDelete () {
      if (this.$store.getters.isFrontdesk) {
        return this.stockRotation.user_id === this.$store.state.authUser.id
      }
      return true
    }
  },
  methods: {
    getDirectionClass () {
      if (this.accumulated) {
        return +this.stockRotation.quantity > 0 ? 'rotation-in' : 'rotation-out'
      }

      if (this.stockRotation.cause.direction === 1) {
        return 'rotation-in'
      } else if (this.stockRotation.cause.direction === -1) {
        return 'rotation-out'
      } else {
        return ''
      }
    },
    getStockrotationInfo (stockRotation) {
      var text = '';
      if (stockRotation.batch) {
        text += `BATCH: ${stockRotation.batch} `
      }
      if (stockRotation.expiry_date) {
        text += `ABLAUF: ${stockRotation.expiry_date} `
      }
      if (stockRotation.production_date) {
        text += `PROD.DATUM: ${stockRotation.production_date} `
      }
      if (stockRotation.serial_number) {
        text += `SERIENN.: ${stockRotation.serial_number} `
      }

      return text;

    },
    formattedQuantity () {
      if (this.accumulated) {
        return this.stockRotation.quantity
      }

      if (this.stockRotation.cause.direction === 1) {
        return `+${this.stockRotation.quantity}`
      } else if (this.stockRotation.cause.direction === -1) {
        return `-${this.stockRotation.quantity}`
      } else {
        return this.stockRotation.quantity
      }
    }
  }
}
</script>

<style>
</style>
